module.exports = __webpack_public_path__ + "static/media/ResponPic10.57701a5a.jpg";